<template>
    <header>
        <nav class="navbar is-fixed-top is-transparent has-border-bottom-gray-light animated fadeInDown"
             role="navigation" aria-label="main navigation">
            <div class="container">

                <!-- Navbar brand -->
                <div class="navbar-brand" style="padding-left: 20px;">
                    <router-link to="home" class="navbar-item is-size-5 has-text-primary">
                        <a class="header-logo"></a>
                        <span class="header-logo-separator"></span>
                    </router-link>
                    <ob-hamburger></ob-hamburger>
                </div>

                <!-- Navbar menu logo and listing -->
                <div class="navbar-menu">
                    <div v-bind:class = "isPersian(currentLocale)?'navbar-end header-links':'navbar-start header-links'">
                        <router-link :to="'get-app'" class="navbar-item is-size-7" active-class="is-active is-active--get-app">{{
                            $t('common:header.getapp') }}
                        </router-link>

                        <router-link :to="'tariff'" class="navbar-item is-size-7" active-class="is-active is-active--tariff">{{
                                $t('common:header.tariff') }}
                        </router-link>

                        <b-dropdown class="navbar-item is-size-7 industries is-hidden-touch">
                            <div class="industries" slot="trigger">
                                {{$t('common:header.solutions') }} <i class="fas fa-angle-down"></i>
                            </div>
                            <b-dropdown-item style="padding-right: 0;" class="uptin-text-7">
                                <router-link :to="'hospitality'" class="navbar-item is-size-7" active-class="is-active is-active--get-app">{{
                                    $t('common:header.hospitality') }}
                                </router-link>
                            </b-dropdown-item>
                            <b-dropdown-item style="padding-right: 0;" class="uptin-text-7">
                                <router-link :to="'healthcare'" class="navbar-item is-size-7" active-class="is-active is-active--get-app">{{
                                    $t('common:header.healthcare') }}
                                </router-link>
                            </b-dropdown-item>
                        </b-dropdown>

                        <a href="https://virgool.io/uptinptt" class="navbar-item is-size-7" active-class="is-active is-active" rel="noopener" v-if="isPersian(currentLocale)">
                            {{ $t('common:footer.blog') }}
                        </a>
                    </div>
                </div>

                <!-- Navbar menu login and language -->
                <div class="navbar-menu">
                    <div v-bind:class = "isPersian(currentLocale)?'navbar-start header-links':'navbar-end header-links'">
                        <span class="navbar-item">
                            <a href="https://panel.uptinptt.ir/" rel="noopener" class="navbar-item is-size-7">
                                {{ $t('common:header.login') }}
                            </a>
                        </span>

                        <span class="navbar-item">
                            <a href="https://panel.uptinptt.ir/signup"
                               class="button sign-up-button is-background-dark3 is-size-7">
                                {{ $t('common:header.register') }}
                            </a>
                        </span>

                        <span class="navbar-item" v-if="isPersian(currentLocale)">
                            <span style="margin-left: 10px;">
                                <a href="tel: +982186093665" class="is-size-7">
                                    {{ $t('common:header:phone') }}
                                </a>
                            </span>
                            <span class="icon is-size-7">
                                <i class="fas fa-phone"></i>
                            </span>
                        </span>

                        <span class="navbar-item is-size-7 industries is-hidden-touch">
                                <b-dropdown class="is-left">
                                    <div class="industries" slot="trigger">
                                        <span>{{getCurrentLang(currentLocale)}} <i class="fas fa-angle-down"></i></span>
                                    </div>
                                    <b-dropdown-item v-bind:class="{ active: currentLocale === 'en' }" v-on:click="changeLocale('en')">English</b-dropdown-item>
                                    <b-dropdown-item v-bind:class="{ active: currentLocale === 'fr' }" v-on:click="changeLocale('fr')">French</b-dropdown-item>
                                    <b-dropdown-item v-bind:class="{ active: currentLocale === 'de' }" v-on:click="changeLocale('de')">Deutsche</b-dropdown-item>
                                    <b-dropdown-item v-bind:class="{ active: currentLocale === 'ar' }" v-on:click="changeLocale('ar')">العربی</b-dropdown-item>
                                    <b-dropdown-item v-bind:class="{ active: currentLocale === 'fa' }" v-on:click="changeLocale('fa')">فارسی</b-dropdown-item>
                                </b-dropdown>
                        </span>

                    </div>
                </div>
            </div>
        </nav>
    </header>
</template>

<style lang="scss">
.sign-up-button {
    width: 8em;
    height: 3.4em !important;
    border: none !important;
    background-size: 1800% 1800%;
    color: white !important;
    overflow: hidden;
    animation: rainbow 10s ease infinite;
    border-radius: 0.9em !important;
}

.sign-up-button:hover {
    background-color: #ffbb00 !important;
    color: black !important;
}

.header-logo {
    background-image: url('../assets/uptin-text-black.webp');
    background-size: 105px 20px;
    background-repeat: no-repeat;
    background-position: center center;
    width: 105px;
    height: 20px;
}

.header-logo-separator {
    width: 1px;
    height: 25px;
    background: #fafafa;
    margin-right: 8px;
}

.header-links {
    .is-active {
        //font-weight: bold;
        color: #000000 !important;

        &--home {
            color: #000000 !important;
        }

        &--poc {
            color: #000000 !important;
        }

        &--tariff {
            color: #000000 !important;
        }

        &--getapp {
            color: #000000 !important;
        }
    }
}

.industries {
    cursor: pointer;
}

</style>

<script>
import obHamburger from './components/hamburger.vue';

export default {
    components: {
        obHamburger
    },
    data() {
        return {
            currentLocale: this.$i18n.i18next.language || window.localStorage.i18nextLng
        };
    },
    methods: {
        getCurrentLang(locale) {
            switch (locale.toLowerCase()) {
                case 'en':
                    return 'English';
                case 'nl':
                    return 'Nederlands';
                case 'gr':
                    return 'Ελληνικά';
                case 'es':
                    return 'Español';
                case 'hu':
                    return 'Magyar';
                case 'fr':
                    return 'Français';
                case 'de':
                    return 'Deutsche';
                case 'fa':
                    return 'Farsi';
                case 'ar':
                    return 'Arabic';
                case 'no':
                    return 'Norsk';
                case 'pt-br':
                    return 'Português (Brasil)';
                case 'sv':
                    return 'Svenska';
                case 'it':
                    return 'Italiano';
                case 'tr':
                    return 'Türkçe';
                default :
                    return 'English';
            }
        },

        changeLocale(locale) {
            this.currentLocale = locale;
            const path = this.$router.currentRoute.path.split('/')[2];
            this.$router.push(`/${locale}/${path}`);


            if (locale === 'fa' || locale === 'ar') {
                document.querySelector('body').classList.add('is-rtl');
                location.reload();
            } else {
                document.querySelector('body').classList.add('is-ltr');
                location.reload();
            }
        },

        isPersian(locale) {
            return locale.toLowerCase() === 'fa' || locale.toLowerCase() === 'ar';
        }
    }
}
</script>
